import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../Components/Loader";
import ErrorAnimationComponent from "../../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import CoursePromo from "../../../Components/CoursesModuleComponents/CoursePromo";
import ListLessonsInCourse from "../../../Components/CoursesModuleComponents/ListLessonsInCourse";
import { getLessonsInCourse } from "../../../apis";
import { transformKeys } from "../../../_helper";

const LessonsInCourse = () => {
  const { courseId } = useParams();
  const [courseDetails, setCourseDetails] = useState([]);
  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [paginator, setPaginator] = useState({});
  const promoVideo = courseDetails?.promoVideo;

  const courseLessons = courseDetails?.lessons?.map((item) =>
    transformKeys(item)
  );

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setIsLoading(true);
    getLessonsInCourse(courseId, currentPage)
      .then((data) => {
        setPaginator({
          current_page: data.data.pagination.current_page,
          last_page: data.data.pagination.total_pages,
        });
        setCourseDetails(data.data);
      })
      .catch((error) => {
        setIsError(
          error.response.data.message || "Error while fetching course lessons"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [courseId, currentPage]);

  if (isLoading) return <Loader />;
  if (isError) return <ErrorAnimationComponent message={isError} />;

  return (
    <>
      <CoursePromo title="Promo Video" videoUrl={promoVideo} />

      <ListLessonsInCourse
        title={"Course Lessons"}
        data={courseLessons || []}
        isLoading={isLoading}
        handlePageChange={handlePageChange}
        paginator={paginator}
        isError={isError}
        setCourseDetails={setCourseDetails}
        setPaginator={setPaginator}
      />
    </>
  );
};

export default LessonsInCourse;
